import TaskManagerEditDto from './TaskManagerEditDto';

export class OptimizationPipelineTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {number[]} */
        this.piMeasurementReaderTasks = null;

        /** @type {number[]} */
        this.labMeasurementReaderTasks = null;

        /** @type {number} */
        this.measurementMergeTask = null;

        /** @type {number} */
        this.outlierDetectionTask = null;

        /** @type {number} */
        this.dataCleanTask = null;

        /** @type {number} */
        this.modelValidationTask = null;

        /** @type {number} */
        this.unitOptimizerTask = null;
    }

    /**
     * @typedef {Object} _OptimizationPipelineTaskEditDto Props
     * @property {number[]} piMeasurementReaderTasks
     * @property {number[]} labMeasurementReaderTasks
     * @property {number} measurementMergeTask
     * @property {number} outlierDetectionTask
     * @property {number} dataCleanTask
     * @property {number} modelValidationTask
     * @property {number} unitOptimizerTask
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _OptimizationPipelineTaskEditDto Props} OptimizationPipelineTaskEditDto Props
     */
    /**
     *
     * @param {OptimizationPipelineTaskEditDto Props} props
     * @returns {OptimizationPipelineTaskEditDto }
     */
    setup(props) {
        super.setup(props);

        this.piMeasurementReaderTasks = props.piMeasurementReaderTasks !== null ? props.piMeasurementReaderTasks : [];
        this.labMeasurementReaderTasks = props.labMeasurementReaderTasks !== null ? props.labMeasurementReaderTasks : [];
        this.measurementMergeTask = props.measurementMergeTask;
        this.outlierDetectionTask = props.outlierDetectionTask;
        this.dataCleanTask = props.dataCleanTask;
        this.modelValidationTask = props.modelValidationTask;
        this.unitOptimizerTask = props.unitOptimizerTask;

        return this;
    }
}

export default OptimizationPipelineTaskEditDto;